const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogLotacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogLotacao`, params);
    },
    $obterRelatorioLogCSVLotacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogLotacaoCsv`, params);
    },
    $obterRelatorioLogPDFLotacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogLotacaoPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
